import ReactDOM from 'react-dom/client'
import './i18n/i18n'
import './index.less'
import './initSentry.ts'
import { StrictMode } from 'react'
import App from './App.tsx'
ReactDOM.createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>
)
